const hasError = (data) => {
    return (data.errors || []).length > 0;
};
export default class Processor {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    validateResponse(response, request) {
        if (response && hasError(response)) {
            return response;
        }
        return null;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    processResponse(response, request) {
        return response;
    }
}
